import { AppHelper } from "../appHelper"
import { CommonApp, CommonAppProps, Entity } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService } from "../core/util/httpManager";
import React from "react";

export class UserSettingsApply extends React.Component<UserSettingsApplyAppProps, any> {
    common = new AppHelper();

    constructor(props) {
        super(props)
        this.common.init(this);
    }

    translations = [];

    save = () => {
        if (this.common.validate(null, true)) {

            let url = null;
            let data = null;

            switch (this.props.entity.Type) {
                case "n":
                    url = "UserSettings/ApplyToNewUser";
                    data = {
                        fromUser: this.props.userName, toUser: this.props.entity.NewUserName
                    };
                    break;
                case "r":
                    url = "UserSettings/ApplyToNewRole";
                    data = {
                        fromUser: this.props.userName, toRole: this.props.entity.NewRoleName
                    };
                    break;
                case "u":
                    url = "UserSettings/ApplyToUsers";
                    data = {
                        fromUser: this.props.userName, toUsers: this.props.entity.Users
                    };
                    break;
                case "g":
                    url = "UserSettings/ApplyToGroups";
                    data = {
                        fromUser: this.props.userName, toGroups: this.props.entity.Groups
                    };
                    break;
                case "m":
                    url = "UserSettings/ApplyToMainGroups";
                    data = {
                        fromUser: this.props.userName, toMainGroups: this.props.entity.MainGroups
                    };
                    break;
                case "e":
                    url = "UserSettings/ApplyPersonalSettingsToUser";
                    data = {
                        fromUser: this.props.userName, toUser: this.props.entity.UserName
                    };
                    break;
            }

            if (url != null && data != null) {
                HTTPService.post(url, data)
                    .then(result => {
                        if (result.Code == 0) {
                            this.props.entity.IsNew = false;
                            NotificationHelper.showSuccessMessage(result.Message);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                        this.common.handlePostSave(result.Code === 0, true);
                        this.setState({});
                    });
            }
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

export interface UserSettingsApplyAppProps extends CommonAppProps {
    entity: EntityUserSettingsApply;
    userName: string;
}

export interface EntityUserSettingsApply extends Entity {
    Type: string;
    Users: Array<string>;
    Groups: Array<string>;
    MainGroups: Array<string>;
    NewUserName: string;
    NewRoleName: string;
    IsRole: boolean;
    UserName: string;
}